<template>
  <div class="bg-n-slate-2 dark:bg-n-slate-3 rounded-xl shadow-sm border border-n-weak">
    <div class="px-6 py-4 border-b border-n-weak">
      <div class="flex items-start justify-between">
        <div>
          <h3 class="text-lg font-semibold text-n-slate-12">
            🔄 Redistribuições Manuais ({{ reassignments.length }})
          </h3>
          <p class="mt-1 text-xs text-n-slate-10">
            Conversas que foram manualmente redistribuídas entre agentes
          </p>
        </div>
        <div class="flex-shrink-0">
          <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-n-amber-3 text-n-amber-11 dark:bg-n-amber-4 dark:text-n-amber-10">
            ⚠️ Atenção
          </span>
        </div>
      </div>
    </div>

    <div class="overflow-y-auto" style="max-height: 500px;">
      <!-- LISTA + INFO BOX quando houver itens -->
      <template v-if="reassignments && reassignments.length > 0">
        <div class="p-6 space-y-3">
          <div
            v-for="item in reassignments"
            :key="item.id"
            class="p-4 bg-n-amber-2 dark:bg-n-amber-3/20 rounded-lg border border-n-amber-6 dark:border-n-amber-7"
          >
            <div class="flex items-center justify-between mb-3">
              <div class="flex items-center gap-2">
                <span class="text-xs text-n-slate-10">
                  {{ item.time_ago }}
                </span>
              </div>
              <div class="flex items-center gap-3">
                <span class="text-xs text-n-slate-10">
                  {{ item.formatted_time }}
                </span>

              </div>
            </div>

            <div class="flex items-center gap-4">
              <!-- From Agent -->
              <div class="flex-1">
                <div class="inline-flex items-center gap-2 px-3 py-2 bg-n-slate-1 dark:bg-n-slate-4 rounded-lg border border-n-weak">
                  <span class="text-xs text-n-slate-10">De:</span>
                  <span class="text-sm font-medium text-n-slate-12">
                    {{ item.assigned_by }}
                  </span>
                </div>
              </div>

              <!-- Arrow -->
              <div class="flex-shrink-0 text-n-amber-9">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </div>

              <!-- To Agent -->
              <div class="flex-1">
                <div class="inline-flex items-center gap-2 px-3 py-2 bg-n-slate-1 dark:bg-n-slate-4 rounded-lg border border-n-weak">
                  <span class="text-xs text-n-slate-10">Para:</span>
                  <span class="text-sm font-medium text-n-slate-12">
                    {{ item.assigned_to }}
                  </span>
                </div>
              </div>

              <!-- To Agent -->
              <div class="flex-2">
                                  <!-- Go to Inbox Button -->
                <button
                  v-tooltip="'Abrir na caixa de entrada'"
                  class="inline-flex items-center justify-center h-8 w-8 rounded-lg text-n-blue-11 hover:text-n-blue-12 hover:bg-n-blue-3 dark:hover:bg-n-blue-4 transition-colors"
                  @click.stop="navigateToConversation(item.display_id)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </button>
              </div>


            </div>
          </div>
        </div>

        <!-- Info Box (só aparece quando tem itens) -->
        <div class="px-6 pb-6">
          <div class="p-4 bg-n-blue-2 dark:bg-n-blue-3/20 rounded-lg border border-n-blue-6 dark:border-n-blue-7">
            <div class="flex items-start gap-3">
              <div class="flex-shrink-0 text-n-blue-9 text-xl">ℹ️</div>
              <div class="flex-1 text-xs text-n-slate-11 space-y-2">
                <p><strong class="text-n-slate-12">O que são redistribuições?</strong></p>
                <p>
                  Estas conversas foram <strong class="text-n-slate-12">inicialmente distribuídas pelo Round Robin</strong>, mas depois foram
                  <strong class="text-n-slate-12">manualmente encaminhadas</strong> por um agente para outro colega.
                </p>

              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- EMPTY STATE -->
      <div v-else class="text-center py-12">
        <div class="text-4xl mb-4">✅</div>
        <p class="text-n-teal-11 dark:text-n-teal-10 font-medium mb-2">
          Nenhuma redistribuição manual
        </p>
        <p class="text-xs text-n-slate-11">
          Todas as conversas permanecem com os agentes originalmente atribuídos
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { computed } from 'vue';

export default {
  name: 'ReassignmentsTable',
  props: {
    reassignments: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const router = useRouter();
    const currentAccountId = useMapGetter('getCurrentAccountId');
    const accountId = computed(() => currentAccountId.value);

    const navigateToConversation = (displayId) => {
      if (!displayId) {
        console.error('[ReassignmentsTable] display_id é obrigatório');
        return;
      }

      router.push({
        name: 'inbox_conversation',
        params: {
          accountId: accountId.value,
          conversation_id: displayId,
        },
      });
    };

    return {
      navigateToConversation,
    };
  },
};
</script>